import { graphql } from "@/graphql/codegen/gql"

graphql(`
  fragment TransferFields on Transfer {
    transferId
    transferType
    status
    as400SyncStatus
    reason
    sourceWarehouseAreaId
    sourceWarehouseArea {
      ...WarehouseAreaBaseFields
    }
    targetWarehouseArea {
      ...WarehouseAreaBaseFields
    }
    referenceCode
    createdByUser {
      firstName
      lastName
      name
    }
    createdOn
    hasDocuments
    products {
      productId
      qtyOnHand
      product {
        productId
        publicId
        externalSystemId
        computedProductStatus
        versionId
        versions {
          id
          versionNumber
          releaseDate
          status
        }
        companyProductDescription
        vendorDescription
        packageUsWeightUom
        packageUsWeightUomDetails {
          name
        }
        company {
          companyId
          name
        }
      }
      pallets {
        referenceNbr
        sourceWarehouseShelvingId
        sourceWarehouseShelving {
          aisleCode
          sectionCode
          binNumber
          binSize
        }
        sourceLocation
        destinationWarehouseShelvingId
        destinationWarehouseShelving {
          aisleCode
          sectionCode
          binNumber
          binSize
        }
        destinationLocation
        lots {
          transferLotId
          rawInventoryId
          qtyToMove
          rawInventory {
            rawInventoryId
            lotNbr
            batchNbr
            location
            totalUnits
            totalPackages
          }
        }
      }
    }
  }
`)
